import { useState, useMemo } from 'react';

import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import useDeviceDetect from 'hooks/useDeviceDetect';
import Logo from 'components/Icons/Logo';
import ShowBreadcrumbs from 'views/Study/components/Teacher/components/ShowBreadcrumbs/ShowBreadcrumbs';

// import SearchBar from './components/SearchBar/SearchBar';
import NotificationButton from './components/NotificationButton/NotificationButton';
import ChatButton from './components/ChatButton/ChatButton';
import ProfileButton from './components/ProfileButton/ProfileButton';
import ProfileDrawer from './components/ProfileDrawer/ProfileDrawer';
import HeaderButton from './components/HeaderButton/HeaderButton';
import UserHeaderSection from './components/UserHeaderSection/UserHeaderSection';

import './Header.scoped.scss';

const Header = () => {
  const [sandwichOpen, setSandwichOpen] = useState(false);

  const { isMobile } = useDeviceDetect();
  const location = useLocation();
  const { pathname } = location;
  const { t } = useTranslation('common');

  const pathnames = pathname.split('/').slice(0, 2).join('/');

  const pageTitleKey = useMemo(() => {
    return {
      '/': 'common:Dashboard/Today',
      '/live': 'Live class',
      '/live/video': 'Video call',
      '/study': 'Study',
      '/grades': 'Grades',
      '/marks': 'Grades',
      '/chat': 'Chat',
      '/edit-profile': 'Profile',
      '/events': 'Events',
      '/quiz': 'Quizzes',
      '/attendance': 'Attendance',
      '/daily-message': 'Message of the day',
      '/permissions': 'UserRights',
    }[pathnames];
  }, [pathnames]);

  const activePageTitle = t(pageTitleKey) || '';

  return (
    <div className="header-container">
      <div className="content">
        <div className="title-container">
          <div className="title-breadcrumbs-container">
            <h2 className="title">{activePageTitle}</h2>
            <ShowBreadcrumbs />
          </div>
          <HeaderButton />
        </div>

        <div className="logo">
          <Logo color="#FFFFFF" fontSize={130} />
        </div>

        <div className="search">{/* <SearchBar /> */}</div>

        <div className="notification-drawer-wrapper">
          <NotificationButton />
        </div>

        <div className="sandwich">
          <ProfileButton
            open={sandwichOpen}
            onClick={() => {
              setSandwichOpen(!sandwichOpen);
            }}
          />
        </div>

        <div className="notification-chat">
          <div className="notifications">
            <NotificationButton />
          </div>
          <div className="chat">
            <ChatButton />
          </div>
        </div>

        <div className="profile">
          <UserHeaderSection />
        </div>

        <ProfileDrawer setOpen={setSandwichOpen} open={sandwichOpen && isMobile} />
      </div>
    </div>
  );
};

export default Header;
